<template>
  <div>
    <b-card title="Middle Mile Operations">
      <b-row>
        <b-col
          cols="12"
          lg="6"
          class="my-1 align-items-start"
        >
          <v-select
            v-model="selectedKey"
            :reduce="option => option.value"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="text"
            placeholder="Select Required Operation"
            :options="statuses"
            class="select-status-dropdown"
            @input="handleChange"
          >
            <template v-slot:option="option">
              <div
                class="option-row"
                :style="{
                  backgroundColor: getLightBackground(option.color),
                }"
                @mouseenter="updateHoverColor(option.color)"
              >
                {{ option.text }}
              </div>
            </template>
          </v-select>
        </b-col>
        <b-col
          md="3"
          class="mt-md-1"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            :to="{ name: 'Selected-middle-mile-operation', params: { id:statusId, key: selectedKey, name: statusName } }"
          >
            <feather-icon
              icon="CornerLeftDownIcon"
              class="mr-50"
            />
            <span class="align-middle">Get Data</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// eslint-disable-next-line import/extensions,camelcase
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import statusColor from '@core/mixins/ui/statusColor'
import StatusMixin from '@core/mixins/status'

const orderRepository = RepositoryFactory.get('order')

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    vSelect,
  },
  mixins: [statusColor, StatusMixin],
  data() {
    return {
      operationSelected: [],
      statuses: [],
      selectedKey: '',
      statusName: '',
      statusId: null,
    }
  },
  mounted() {
    this.getStatusList()
  },
  methods: {
    async getStatusList() {
      const data = localStorage.getItem('rider_operations') ? JSON.parse(localStorage.getItem('rider_operations')) : (await orderRepository.getStatusList('middle')).data.data
      if (!localStorage.getItem('rider_operations')) localStorage.setItem('rider_operations', JSON.stringify(data))
      const colorMap = this.getColorMap()
      this.statuses = data.map(n => ({
        id: n.id, text: n.name, value: n.key, color: colorMap[n.color] || n.color || '#6c757d',
      }))
    },
    handleChange() {
      const selectedStatus = this.statuses.find(row => row.value === this.selectedKey)
      const words = selectedStatus.text.toLowerCase().split(' ')
      const titleCaseWords = words.map(word => {
        if (word.charAt(0) === '(') {
          return `(${word.charAt(1).toUpperCase()}${word.slice(2)}`
        }
        if (word.includes('/') || word.includes('-')) {
          const separator = word.includes('/') ? '/' : '-'
          return word
            .split(separator)
            .map(part => part.charAt(0).toUpperCase() + part.slice(1))
            .join(separator)
        }
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      const titleCaseString = titleCaseWords.join(' ')
      this.statusName = decodeURIComponent(titleCaseString).replace(/ /g, '-')
      this.statusId = selectedStatus.id
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
.select-status-dropdown .vs__dropdown-menu .vs__dropdown-option--highlight{
    background-color: var(--hover-color) !important;
    color: #fff !important;
}

.option-row {
  width: 100%;
  padding: 6px 10px;
  display: block;
  color: inherit !important;
  font-weight: 500;
}
</style>
